import store from '@/store'
import dashboard from './dashboard'
import reply from './reply'
import poster from './poster'
import instagram from './instagram'
import bot from './bot'

export default [
  {
    title: 'menu.home',
    icon: 'HomeIcon',
    route: 'owner:home',
    shared: true,
  },
  {
    title: 'menu.owner-accounts',
    icon: 'UsersIcon',
    route: 'owner:pages-accounts',
    shared: true,
  },
  {
    title: 'menu.subscribers',
    icon: 'FileIcon',
    route: 'owner:subscribers',
    hide: () => !store.getters['auth/isReferral'],
  },
  ...reply, ...poster, ...instagram, ...bot, ...dashboard]
